import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Device from './device/Index.vue';
import Dialog from './dialog/Index.vue';
import { onMounted, reactive } from 'vue'
import { useStore } from 'vuex'
import fyApi from '@/api/fyxApi'
import { showAd } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const temp = reactive({
    ready: false
})
onMounted(() => {
    if (window.matchMedia) {
        let dark = window.matchMedia('(prefers-color-scheme: dark)').matches
        store.commit('loadDarkMode', dark ? 'true' : 'false')
    } else {
        store.commit('loadDarkMode')
    }
    temp.ready = true
    checkAd()
})

async function checkAd() {
    try {
        let now = Date.now() / 1000
        let ad = await fyApi.getAd()
        if (ad.interval > 0) {
            let last = parseInt(localStorage.getItem('fad') || '0')
            if (!isNaN(last) && now - last < ad.interval) {
                return
            }
        }
        localStorage.setItem('fad', now + '')
        showAd(store, ad)
    } catch (e) {
        console.info(e)
    }
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_router_view, null, null, 512), [
      [_vShow, _unref(temp).ready]
    ]),
    _createVNode(Dialog),
    _createVNode(Device)
  ], 64))
}
}

})